import { Checkbox } from "primereact/checkbox";

import commonStyle from "../../content/CommonStyles.module.css";

const CheckboxInput = ({formik, paramName, label, customStyle="", mainStyle}) => {

    return (
        <div className={`${mainStyle ?? commonStyle.formInput} ${customStyle}`} >
            <div className={`${commonStyle.checkboxStyle} p-inputgroup flex-1`}>
                <Checkbox
                    name="paramName"
                    onChange={() => { formik.setFieldValue(paramName, !formik.values[paramName]) }}
                    checked={formik.values[paramName]}
                    className={formik.errors[paramName] && formik.touched[paramName] ? 'p-invalid' : ""}
                />
                <label className={`${formik.errors[paramName] && formik.touched[paramName] ? "text-red-500" : ""}`}>{label}</label>
            </div>
        </div>
    )
}

export default CheckboxInput;